<!-- Cartel: reemplaza el lugar donde antes vivía la barra de instructivos -->
<div class="col-span-12 rounded-md shadow-md bg-white p-6 text-center">
  <i class="pi pi-book text-3xl text-primary mb-2 block"></i>
  <p class="text-slate-600">
    Los instructivos siguen disponibles en el sistema.
    <a
      class="text-primary font-semibold cursor-pointer hover:underline"
      routerLink="/capacitaciones/instructivos"
    >
      Hacé clic acá
    </a>
    o usá el botón <b>Instructivos</b> del margen derecho para acceder.
  </p>
</div>

<!-- Botón flotante, fijo al viewport — se oculta mientras el panel está
     abierto, ya que el panel tiene su propia manija para colapsar a la
     misma altura (ver petrol-drawer) -->
@if (!isOpen) {
  <button
    type="button"
    class="group fixed right-0 top-32 z-40 flex items-center gap-2 h-12 w-12 hover:w-40 pl-3 bg-primary text-white shadow-lg overflow-hidden transition-all duration-300"
    style="border-radius: 12px 0 0 12px;"
    (click)="open()"
    aria-label="Ver instructivos"
  >
    <i class="pi pi-book text-lg flex-shrink-0" aria-hidden="true"></i>
    <span
      class="whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-sm font-medium"
    >
      Instructivos
    </span>
  </button>
}

<!-- Panel lateral: siempre montado (no @if), controlado por [open] — así
     `c-card-instructivo` no vuelve a cargar sus datos cada vez que se abre -->
<petrol-drawer
  [open]="isOpen"
  title="Instructivos"
  width="260px"
  (closed)="close()"
>
  <c-card-instructivo />
</petrol-drawer>
